/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Export all models
  Date: April 2020
**/

import policyModel from './policy';


const storeModel = {
  policy: policyModel,
};

export default storeModel;
